.root {
  position: relative;
}

.header {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.organizationBadge {
  align-items: center;
  border: 1px solid var(--color-outline);
  border-radius: 8px;
  display: flex;
  margin-right: 16px;
  min-width: 0;
}

.organizationName {
  color: var(--color-text-on-primary);
}

.toggleButton {
  align-items: center;
  background: transparent;
  border: none;
  color: var(--color-text);
  cursor: pointer;
  display: flex;
  font-size: 40px;
  justify-content: center;
  padding: 0;
}

.toggleButtonOpen {
  color: var(--color-background);
}

.profileButtonInner {
  position: relative;
  display: inline-flex;
}

.badge {
  align-items: center;
  background-color: var(--color-primary);
  border: 2px solid white;
  border-radius: 50%;
  color: white;
  display: flex;
  font-size: 0.625rem;
  font-weight: 700;
  height: 18px;
  justify-content: center;
  min-width: 18px;
  padding: 0 2px;
  position: absolute;
  right: 12px;
  top: -4px;
}

.profileFrame {
  border: 1px solid #441144;
  border-radius: var(--profile-image-radius);
  display: inline-flex;
  margin-right: 16px;
  overflow: hidden;
}

.menu {
  background-color: var(--color-background);
  border: 1px solid var(--color-muted);
  border-radius: 16px;
  box-shadow: 7px 10px 14px 3px rgba(0, 0, 0, 0.26);
  display: flex;
  flex-direction: column;
  font-family: var(--font-family-base);
  padding: 16px;
  position: absolute;
  right: 0;
  width: 300px;
  z-index: 200;
}

.menuHeader {
  justify-content: center;
  margin-bottom: 16px;
  text-align: center;
}

.userDetails {
  margin: 16px 0;
}

.userImage,
.organizationLogo {
  display: flex;
  justify-content: center;
}

.candidateName {
  margin: 8px 0;
}

.userMeta {
  font-size: var(--font-size-small);
}

.organizationSummary {
  margin-top: 32px;
}

.languageSelector {
  margin-top: 32px;
  padding: 0 32px;
}

.navItem {
  background: transparent;
  border: none;
  box-sizing: border-box;
  color: var(--color-text);
  cursor: pointer;
  display: block;
  font-family: var(--font-family-base);
  font-size: var(--font-size-normal);
  font-weight: 400;
  margin-top: 0;
  padding: 0.5rem 0 0.5rem 16px;
  text-align: left;
  text-decoration: none;
  width: 100%;
}

.navItem:hover {
  text-decoration: underline;
}

.navItemIndented {
  padding-left: 32px;
}

.separator {
  border: 0;
  border-top: 1px solid var(--color-text);
  margin: 12px 0;
}

@media (max-width: 767px) {
  .organizationBadge {
    display: none;
  }

  .menu {
    box-sizing: border-box;
    max-width: calc(100vw - 2rem);
  }
}
